import React from 'react';
import Typography from '@material-ui/core/Typography';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import useStyles from './defaultStyles';
import useCommonStyles from './commonStyles';
import {thumborImageUrl} from '../../Utility'


export default () => {
  const classes = useStyles();
  const commonClasses = useCommonStyles();
  return(
    <div className={`${classes.bannerContainer} ${commonClasses.parallaxLayer}`}>
      <img src={thumborImageUrl("https://app.travclan.com/media/appcms/greece.jpg", 1000, 0)} className={classes.bgVideo} />
      <div className={classes.bgVideoOverlayContainer} id="bgVideoOverlayContainer">
        <div className={classes.bannerText}>
          <div>
            <ErrorOutlineIcon fontSize="large" className={classes.errorIcon}/>
            <br />
            <Typography align="right" variant="h3">SITE UNDER MAINTENANCE.<br />PLEASE TRY AGAIN LATER</Typography>
          </div>
        </div>
      </div>
    </div>
  )
}
